import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import Chip from "@ui-kit/form/chip";

type BooleanFlag = {
  id: string;
  label: string;
  flag: boolean;
};

interface IProps {
  flag: boolean;
  flags: BooleanFlag[];
  onSetFlag: (flag: boolean) => void;
  className?: string;
}

const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  > * + * {
    margin-left: 6px;
  }
`;

const FilterbarPanelsBoolean = ({
  flags,
  onSetFlag,
  className,
  flag,
}: IProps) => {
  const toggleFlag = (_flag: boolean) => {
    if (flag !== _flag) {
      onSetFlag(_flag);
    } else {
      onSetFlag(null);
    }
  };
  return (
    <div className={className}>
      <Options>
        {!!flags &&
          map(flags, ({ id, label, flag: _flag }) => (
            <Chip
              key={id}
              label={label}
              onClick={() => toggleFlag(_flag)}
              status={_flag === flag ? (_flag ? "include" : "exclude") : "none"}
              noLinethrough
            />
          ))}
      </Options>
    </div>
  );
};

export default FilterbarPanelsBoolean;
